// extracted by mini-css-extract-plugin
export default {"title":"HeroContent__title-Jpcg","component":"HeroContent__component-inhi","description":"HeroContent__description-XWmd"};